'use strict';

function controller($attrs, $http, appConfig) {
    const vm = this;

    vm.recommendations = [];

    vm.init = function() {
        var pageId = parseInt($attrs.pageId, 10);

        if (!pageId) {
            return;
        }

        $http.get(appConfig.recommendationsFeedURL + '/' + pageId, { cache: true, withCredentials: true })
            .then(function (response) {
                vm.recommendations = response.data;
            });
    };

    return vm;
}

module.exports = [
    '$attrs',
    '$http',
    'appConfig',
    controller
]



// WEBPACK FOOTER //
// ./widgets/controllers/RecommendedEvents.js